export const isPdfLink = link => link.contentType === 'application/pdf';